export const MAX_SERVICE_LINKS_TO_DISPLAY = 5;

export const EVENT_CONTACT_PREFIX = 'contact: ';
export const EVENT_CONTACT_FOOTER = `${EVENT_CONTACT_PREFIX}clicked link in footer`;
export const EVENT_CONTACT_GENERIC = `${EVENT_CONTACT_PREFIX}clicked link in form`;
export const EVENT_CONTACT_LEVEL_UP = `${EVENT_CONTACT_PREFIX}clicked level up link`;
export const EVENT_CONTACT_LOG_IN = `${EVENT_CONTACT_PREFIX}clicked log in button`;
export const EVENT_CONTACT_SIGN_UP = `${EVENT_CONTACT_PREFIX}clicked sign up button`;
export const EVENT_CONTACT_QA_RESPONSE = `${EVENT_CONTACT_PREFIX}responded to quick answer`;
export const EVENT_CONTACT_QA_CONTINUE = `${EVENT_CONTACT_PREFIX}continued after helpful quick answer`;
export const EVENT_CONTACT_INIT = `${EVENT_CONTACT_PREFIX}opened form`;
export const EVENT_CONTACT_STEP = `${EVENT_CONTACT_PREFIX}changed node`;
export const EVENT_CONTACT_SENT = `${EVENT_CONTACT_PREFIX}sent form`;
export const EVENT_CONTACT_ERROR = `${EVENT_CONTACT_PREFIX}got error sending form`;
export const EVENT_CONTACT_DISCUSSION = `${EVENT_CONTACT_PREFIX}clicked community discussion`;

export const CSS_CONTAINER_MAX_WIDTH = `${20 + 746 + 20}px`;
export const CSS_CONTAINER_DEFAULT_PADDING = '0 20px';
export const PAGE_VIEW_EVENT = 'web_analytics.tracking.page_view.PageViewEvent';
export const USER_INTERACTION_EVENT =
  'web_analytics.tracking.user_interaction.UserInteractionEvent';

// Also found here in live-chat repo here: https://gitlab.com/zapier/team-support-systems-engineering/live-chat/-/blob/main/packages/gtm-live-chat/src/shared/constants.js?ref_type=heads#L60
// TODO - unify in either a new library or in the get-help library
export const DAYS_FOR_PAID_SUPPORT_AFTER_TRIAL = 30;

export const USER_TIMEZONE_ZD_TAG_PREFIX = 'browser-tz-';

const isProd = !window.location.href.includes('zapier-staging');

// To be used to send the correct field IDs to Zendesk depending on environment
// Key names are synthesized from the field names in Zendesk: https://zapier.zendesk.com/admin/objects-rules/tickets/ticket-fields
export const ZENDESK_CUSTOM_FIELD_IDS = {
  BILLING_WHAT_WOULD_YOU_LIKE_TO_DO: isProd ? 360044340931 : 29657802461325,
  TASKS_WHATS_THE_ISSUE: isProd ? 360044340911 : 29657778430989,
  ACCESS_WHAT_WOULD_YOU_LIKE_TO_DO: isProd ? 360044340971 : 29657820157837,
  REPORT_BUG_OR_REQUEST_FEATURE: isProd ? 13794605780237 : 29657839769485,
  ACCOUNTS_WHAT_CAN_WE_HELP_WITH: isProd ? 360043779271 : 29657778187277,
  MORE_INFORMATION_REQUEST: isProd ? 360043776052 : 29657778141069,
  ABOUT_WHAT_CAN_WE_HELP_WITH: isProd ? 360043779291 : 29657793642125,
  ZAPS_WHAT_CAN_WE_HELP_WITH: isProd ? 360043779251 : 29657819848333,
  ERROR_WHAT_IS_THE_ERROR: isProd ? 360044340631 : 29657810431373,
  TROUBLESHOOTING_TELL_US_MORE: isProd ? 360043776252 : 29657810163341,
  FIELDS_WHERE_IS_THE_PROBLEM: isProd ? 360044312032 : 29657802336525,
  CRITICAL_TICKET: isProd ? 29509035470861 : 29657865864973,
  CRITICAL_TICKET_PRIMARY_REASON: isProd ? 36226534946701 : 36316781212045,
  CRITICAL_TICKET_BLOCKED_OUTCOME: isProd ? 36226680704397 : 36316780339725,
  CRITICAL_TICKET_SCALE_OF_IMPACT: isProd ? 36226690010253 : 36316790394637,
  CRITICAL_TICKET_TROUBLESHOOTING_DETAILS: isProd
    ? 36226747424013
    : 36316790512781,
};
